import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable, SelectSubscribe } from '@macs-frontend/decorators';
import {
  MdNotification,
  MdNotificationItem,
  MdNotificationItemType,
} from '@macs-frontend/web-macs/shared';
import { Store } from '@ngrx/store';
import { getNotification } from '../../../reducers/meta';

@Component({
  selector: 'md-notifications',
  templateUrl: './notifications.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent extends BaseComponent {
  @SelectSubscribe(getNotification)
  notification?: MdNotification;

  notificationTypes = Object.values(MdNotificationItemType);

  alertClasses = {
    [MdNotificationItemType.ERROR]: 'message-alert_error',
    [MdNotificationItemType.WARNING]: 'message-alert_warning',
    [MdNotificationItemType.INFO]: 'message-alert_info',
  };

  constructor(
    private router: Router,
    readonly cdr: ChangeDetectorRef,
    readonly store$: Store<any>,
  ) {
    super();
    makeSelectable(this, { cdr, store$ });
  }

  close() {
    this.router.navigate([{ outlets: { modal: null } }], {
      queryParamsHandling: 'merge',
      preserveFragment: true,
    });
  }

  getTypedNotificationItem(item: MdNotificationItem) {
    return item;
  }

  getTypedNotificationItemType(type: MdNotificationItemType) {
    return type;
  }

  hasNotifications(): boolean {
    const notification = this.notification;
    if (!notification) {
      return false;
    }

    return this.notificationTypes.some(nType => notification[nType]);
  }
}
